export const CarAttribute = ({label, value}) => {
    return (
        <div className='flex items-start justify-between text-sm max-h-[22px]'>
            <div className="text-gray-500 mr-2">{label}</div>
            <div className="font-semibold text-right truncate overflow-hidden whitespace-nowrap">{value}</div>
        </div>
    )
}